"use strict";
export const VDUsedMock = (mock) => {
  mock.onPost(/\/v1\/virtual-desktops\/(\d+)\/used/).reply((cofig) => {
    let _response = {};
    return [200, _response];
  });
  mock.onDelete(/\/v1\/virtual-desktops\/(\d+)\/used/).reply((config) => {
    let _response = {};
    return [200, _response];
  });
};
